export default __webpack_public_path__ + "static/media/logo-white.cd0a68be.svg";